import React from "react";
import { Drawer, Toolbar, DrawerProps } from "@mui/material";

export interface SideBarProps extends Omit<DrawerProps, "variant" | "anchor"> {
    children: React.ReactNode;
    logo?: React.ReactNode;
}

const defaultLogo = (
    <img
        src="https://cdn.fs.brandfolder.com/4qGXTNoS46tZUdvFZpXg"
        width="60%"
    />
);

export const SideBar = ({
    children,
    logo = defaultLogo,
    ...props
}: SideBarProps) => {
    return (
        <Drawer
            variant={"permanent"}
            anchor={"left"}
            sx={{
                width: "256px",
                flexShrink: 0,
                "& .MuiDrawer-paper": {
                    width: "256px",
                    boxSizing: "border-box",
                },
            }}
            {...props}
        >
            <Toolbar sx={{ justifyContent: "center" }}>{logo}</Toolbar>
            {children}
        </Drawer>
    );
};
